import Link from "next/link";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { shortDate } from "../../pages/blog/[...slug]";

export default function LearnCard(props) {
    return (
        <Link href={props.url}>
            <a>
                <div className="relative grid grid-cols-1 py-10 border-t border-t-gray-100 dark:border-t-gray-900 max-sm:gap-3 sm:grid-cols-3">
                    <div>
                        <div className="text-sm/5 max-sm:text-gray-700 sm:font-medium">
                            {shortDate(props.date)}
                        </div>
                        <div className="text-sm/5 mt-1 text-gray-700">
                            {props.author}
                        </div>
                    </div>
                    <div className="sm:col-span-2 sm:max-w-2xl">
                        <h2 className="text-sm/5 font-medium">{props.title}</h2>
                        <p className="mt-3 text-sm/6 text-gray-500">
                            {props.description}
                        </p>
                        <div className="mt-4 flex items-center gap-1 text-sm/5 font-medium text-gray-700 dark:text-gray-300">
                            <span className="absolute inset-0" />
                            Read more
                            <ChevronRightIcon className="w-4 h-4" />
                        </div>
                    </div>
                </div>
            </a>
        </Link>
    );
}
